
const ErrorHandlingAction = {
  SET_STATE: "responseHandling/SET_STATE",
  HANDLE_STATE: "responseHandling/HANDLE_STATE",
  SET_ERROR: "responseHandling/SET_ERROR",
  SET_SUCCESS: "responseHandling/SET_SUCCESS",
  SET_WARNING: "responseHandling/SET_WARNING",
};

export default ErrorHandlingAction;
